<template>
  <div class="form-group">
    <label for="zone">Zone</label>
    <app-multiselect
      id="zone"
      :value="options.find(o => o.value === value)"
      :options="options"
      label="label"
      track-by="value"
      placeholder="-- National --"
      @input="option => $emit('input', option ? option.value : 0)"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AppMultiselect from '@/components/AppMultiselect'

export default {
  name: 'ZoneSelect',
  components: { AppMultiselect },
  props: {
    value: { type: Number, default: 0 }
  },
  data() {
    return {
      zones: []
    }
  },
  computed: {
    options() {
      return [{ label: '-- National --', value: 0 }].concat(
        this.zones.map(zone => ({ label: zone.name, value: zone.id }))
      )
    }
  },
  created() {
    axios.get(`${this.$api}/zone/list`).then((response) => {
      if (response.data.status === 'success') {
        this.zones = response.data.data
        this.$emit('loaded', this.zones)
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZoneSelect.vue